import { getAuthHeaders, setStatusBarColor, setStatusBarTheme } from './sessionStorage'
import { applyDevMockInstalledUpiIntents } from './dev/installedUpiIntentsDev'

interface ShareInterface {
  image?: string
  text?: string
}

enum NavigationStyle {
  PUSH = 'PUSH',
  PUSH_SINGLETON = 'PUSH_SINGLETON',
  PUSH_REPLACEMENT = 'PUSH_REPLACEMENT',
  PUSH_REPLACEMENT_WITHOUT_ANIMATION = 'PUSH_REPLACEMENT_WITHOUT_ANIMATION',
  PUSH_AND_REMOVE_ALL = 'PUSH_AND_REMOVE_ALL',
  POP = 'POP',
  POP_AND_REFRESH = 'POP_AND_REFRESH',
  POP_AND_REFRESH_APP = 'POP_AND_REFRESH_APP',
  POP_ALL = 'POP_ALL',
  POP_TO_FIRST = 'POP_TO_FIRST',
  NONE = 'NONE',
  ANIMATION = 'ANIMATION',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  EXIT_APP = 'EXIT_APP',
  POP_AND_PUSH_WIDGET = 'POP_AND_PUSH_WIDGET',
  PUSH_AND_REMOVE_UNTIL = 'PUSH_AND_REMOVE_UNTIL',
  PUSH_BOTTOM_SHEET_AND_REPLACE = 'PUSH_BOTTOM_SHEET_AND_REPLACE',
  PUSH_BOTTOM_SHEET_AND_REMOVE_UNTIL = 'PUSH_BOTTOM_SHEET_AND_REMOVE_UNTIL',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Sends an event to app for popping top screen
 */
export const handleClose = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"cta",  "extras":{"type":"CTA","navigationStyle":"POP"}}`)
    }
  } catch (e: any) {
    // trackEvent(`APP_BIRDGE_handleClose_ERROR`, { error: e.message })
  }
}

/**
 * Sends an event to app for popping top screen
 */
export const goBack = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function":"cta",  "extras":{"type":"CTA","ctaType":"DEFAULT","navigationStyle":"POP"}}`
      )
    }
  } catch (e: any) {
    console.error('back not possible')
    // trackEvent(`APP_BIRDGE_goBack_ERROR`, { error: e.message })
  }
}

/**
 * Sends an event to app via bridge to changes the status bar color
 *
 * @param {string} color - text color
 * @param {string} theme - status bar theme
 */
export const updateStatusBarV2 = (color = '000000', theme = 'light'): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"systemOverlay", "extras":{"theme":"${theme}","color": "0xFF${color}"}}`)
    }
  } catch (e: any) {
    // trackEvent('UPDATE_STATUS_BAR_FAILED', { error: e.message });
  }
}

/**
 * Sends an event to app via bridge to changes the status bar color
 *
 * @param {string} color - text color
 * @param {string} theme - status bar theme
 */
export const updateStatusBar = (color = '000000', theme = 'light'): void => {
  try {
    const authHeaders = getAuthHeaders()
    const { 'app-version': appVersion = '' } = authHeaders

    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"systemOverlay", "extras":{"theme":"${theme}","color": "0xFF${color}"}}`)
    }

    // trackEvent('APP_VERSION_CHECK_FOR_UPDATE_STATUS_BAR_FAILED', { appVersion })
  } catch (e: any) {
    console.log('failed in updating status bar')
    // trackEvent('UPDATE_STATUS_BAR_FAILED', { error: e.message });
    // console.log("event send")
  }
}

export const updateStatusBarWithoutAuth = (color = '000000', theme = 'light'): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"systemOverlay", "extras":{"theme":"${theme}","color": "0xFF${color}"}}`)
    }
  } catch (e: any) {}
}

export const handleNach = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"nach","extras": {
				"navigationStyle":"POP",
				"ctaType":"DEFAULT"
			 }}`)
    }
  } catch (e: any) {
    console.error('nach call failed')
  }
}

export const lightImpactVibrate = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"haptics","extras": {}}`)
    }
  } catch (e: any) {
    console.error('haptics failure')
  }
}

/**
 * Sends an event to app via bridge to changes the status bar color
 *
 * @param {string} color - text color
 * @param {string} theme - status bar theme
 */
export const updateAppStatusBar = (color = '000000', theme = 'light', saveToSessionStorage = true): void => {
  try {
    const authHeaders = getAuthHeaders()
    const { 'app-version': appVersion = '' } = authHeaders

    if (uniAppHandle) {
      if (saveToSessionStorage) {
        setStatusBarColor(color)
        setStatusBarTheme(theme)
      }
      console.log('updateAppStatusBar', color, theme)
      uniAppHandle.postMessage(`{"function":"systemOverlay", "extras":{"theme":"${theme}","color": "0xFF${color}"}}`)
    }
  } catch (e: any) {
    // trackEvent('UPDATE_STATUS_BAR_FAILED', { error: e.message })
  }
}

/**
 * Takes use to home screen
 */
export const goToHome = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
						"type": "CTA",
						"ctaType": "DEFAULT",
						"method": "GET",
						"navigationStyle": "PUSH_AND_REMOVE_ALL",
						"url": "/v1/user/home"
				  	}
				}`
      )
    }
  } catch (e: any) {
    console.log(e)
    // trackEvent('GO_TO_APP_HOME_FAILED', { error: e.message })
  }
}

export const goToDashboard = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
						"type": "CTA",
						"ctaType": "DEFAULT",
						"method": "GET",
						"navigationStyle" : "PUSH_AND_REMOVE_ALL",
						"url" : "/v1/powerup/user/home?tabTypeEnum=goal_setting"
				  	}
				}`
      )
    }
  } catch (e: any) {
    console.error('error redirecting to dashboard', e.message)
  }
}

export const goToPortfolioDashboard = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
						"type": "CTA",
						"ctaType": "DEFAULT",
						"method": "GET",
						"navigationStyle" : "PUSH_AND_REMOVE_ALL",
						"url" : "/v1/powerup/user/home?tabTypeEnum=portfolio"
				  	}
				}`
      )
    }
  } catch (e: any) {
    console.error('error redirecting to dashboard', e.message)
  }
}

export const openMail = (emailAddress: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
  						"type" : "CTA",
 						"ctaType" : "EMAIL_CTA",
  						"method" : "GET",
  						"navigationStyle" : "NONE",
  						"url" : "mailto:${emailAddress}"
					}
				}`
      )
    }
  } catch (e: any) {
    console.error('error sending email', e.message)
  }
}

/** Opens WhatsApp via native bridge (`ctaType: WHATSAPP_CTA`). Pass a full `wa.me` / WhatsApp URL. */
export const openWhatsapp = (url: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
  						"type" : "CTA",
 						  "ctaType" : "WHATSAPP_CTA",
  						"method" : "GET",
  						"navigationStyle" : "NONE",
  						"url" : "${url}"
					}
				}`
      )
    }
  } catch (e: any) {
    console.error('error opening whatsapp', e.message)
  }
}

export const goToRefineDashboard = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{	
					"function":"cta",
					"extras":{
						"type": "CTA",
						"ctaType": "DEFAULT",
						"method": "GET",
						"navigationStyle" : "PUSH_REPLACEMENT",
						"url" : "/v1/powerage/refine/dashboard"
				  	}
				}`
      )
    }
  } catch (e: any) {
    console.error('error redirecting to refine dashboard', e.message)
  }
}

/**
 * Calls apps event to share intent with content
 * @param data
 */
export const shareWithApp = (data: ShareInterface): void => {
  const { image = '', text = '' } = data

  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{
					"function": "share",
					"extras": {
					"image": "${image.split(',')[1]}",
					"text": "${text}"
					}
				}`
      )
    }
  } catch (e: any) {
    // trackEvent('SHARING_FAILED', { error: e.message })
  }
}

export type TrackEventPayload = {
  ScreenName?: string
  screenType?: string
  responseName?: string
  fundName?: string
  fundIsin?: string
  eventId?: string
  buttonLabel?: string
  scrollSection?: string
  bottomSheetName?: string
  amount?: number | string
  cta_name?: string
  autopayMode?: string
  upiApps?: string[]
  netBankingAccounts?: string[]
}

export const trackEvent = ({ eventName, payload }: { eventName: string; payload: TrackEventPayload }) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{
					"function": "event",
          "eventName" : "${eventName}",
					"payload" : ${JSON.stringify(payload)}
				}`
      )
    }
  } catch (e: any) {
    console.log(`{
					"function": "event",
          "eventName" : "${eventName}",
					"payload" : ${JSON.stringify(payload)}
				}`)
    console.error('Error occurred while tracking event')
  }
}

/**
 * closes the story
 * @param resolution
 */
export const closeStory = (): void => {
  goToHome()
}

/**
 * Opens URL in browser
 * @param {string} url
 */
export const openInBrowser = (url: string): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta","extras": { "type": "CTA", "ctaType": "WEB_REDIRECT","url": "${url}"}}`
      )
    }
  } catch (e: any) {
    console.error('error opening the url in browser', e?.message)
  }
}

/**
 * Requests app to list all UPI intents
 */
export const getUPIIntents = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "getUpiIntents"}`)
    }
  } catch {
    // Native bridge unavailable in browser dev.
  }

  // After native call (or skip), seed dev mocks so UPI app lists work locally.
  applyDevMockInstalledUpiIntents()
}

export type UpiPayParams = {
  upiLink: string
  packageName?: string | null
}

/**
 * Opens the selected UPI app with platform-specific handling (iOS / Android).
 * Maps to Flutter `_callUpiPay` via `paymentInstrumentController.upiPay`.
 */
export const upiPay = ({ upiLink, packageName }: UpiPayParams): void => {
  try {
    if (!uniAppHandle || !upiLink?.trim()) return

    const extras: Record<string, string> = {
      upiLink: upiLink.trim()
    }

    if (packageName?.trim()) {
      extras.packageName = packageName.trim()
    }

    uniAppHandle.postMessage(
      JSON.stringify({
        function: 'upiPay',
        extras
      })
    )
  } catch (e: any) {
    console.error('error triggering UPI pay', e?.message)
  }
}

export const upgradeLimit = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
				"type": "CTA",
				"ctaType": "DEFAULT",
				"method": "GET",
				"navigationStyle": "PUSH",
				"url": "/v2/p2p/common/upgrade-limit"
			}}`)
    }
  } catch (e: any) {
    console.log('error in getting upgradeLimit CTA', e.message)
  }
}

export const openEliteLandingPage = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
    "type": "CTA",
    "ctaType": "DEFAULT",
    "method": "GET",
    "navigationStyle": "PUSH",
    "url": "/v2/portfolio/getElite"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting elite landing page', e.message)
  }
}

export const openPrimeLandingPage = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
    "type": "CTA",
    "ctaType": "DEFAULT",
    "method": "GET",
    "navigationStyle": "PUSH",
    "url": "/v2/portfolio/getElite?landingPageType=PRIME"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting prime landing page', e.message)
  }
}

export const goToReferral = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
        "type": "CTA",
        "eventId": "REFER_AND_EARN_CTA_CLICKED_WEB",
        "refreshScreen": false,
        "url": "/v2/referral/invite-page",
        "isNavigationDeferred": false,
        "method": "GET",
        "navigationStyle": "PUSH",
        "navigateWithShuttleAnimation": false,
        "ctaType": "DEFAULT"
      }}`)
    }
  } catch (e: any) {
    console.log('error in goToReferral', e.message)
  }
}

export const openRebalanceQuestionnaire = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
        "type": "CTA",
        "ctaType": "DEFAULT",
        "method": "GET",
        "navigationStyle": "PUSH",
        "url": "/v2/portfolio/web-redirection/power-rebalance/questionnaire"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting rebalance questionnaire', e.message)
  }
}

export const openRebalanceQuestionnaireFromL1 = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
        "type": "CTA",
        "ctaType": "DEFAULT",
        "method": "GET",
        "navigationStyle": "PUSH",
        "url": "/v2/portfolio/web-redirection/power-rebalance/retake/questionnaire"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting rebalance questionnaire from l1', e.message)
  }
}

export const openRebalancePlanSummary = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
        "type": "CTA",
        "ctaType": "DEFAULT",
        "method": "GET",
        "navigationStyle": "PUSH",
        "url": "/v2/portfolio/web-redirection/power-rebalance/summary"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting rebalance plan', e.message)
  }
}

export const openRebalancePlanSummaryRemove = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
        "type": "CTA",
        "ctaType": "DEFAULT",
        "method": "GET",
        "navigationStyle": "PUSH_REPLACEMENT",
        "url": "/v2/portfolio/web-redirection/power-rebalance/summary"
      }}`)
    }
  } catch (e: any) {
    console.log('error in getting rebalance plan', e.message)
  }
}

/**
 * Requests app to list all UPI intents
 */
export const getSupport = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": {
				"type": "CTA",
				"method": "POST",
				"navigationStyle": "BOTTOM_SHEET",
				"url": "/v1/user-support/get",
				"requestPayload": "{\\"postBackParams\\":{\\"supportType\\":\\"INVESTMENT\\"}}"
			  }}`)
    }
  } catch (e: any) {
    console.log('error fetching support bottom sheet from app', e.message)
  }
}

export const customisedSupportCTA = (customisedCta: any): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": ${JSON.stringify(customisedCta)}}`)
    }
  } catch (e: any) {
    console.log('error fetching custom cta from app', e.message)
  }
}

export const copyViaApp = (text: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta", "extras": {
				"type": "CTA",
				"ctaType": "COPY_TO_CLIPBOARD",
				"data": "${text}",
				"toast": {
					"type": "TOAST",
					"text": {
					"type": "TEXT",
					"text": "Transaction ID Copied"
					},
					"bgColor": "0xFF24423E",
					"durationInMilli": 3000
				}
			}}`)
    }
  } catch (e: any) {
    console.log('error fetching get support bottom sheet from app', e.message)
  }
}

export const startP2PInvestment = (): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": 
			{
				"type": "CTA",
				"ctaType": "DEFAULT",
				"method": "POST",
				"navigationStyle": "PUSH",
				"url": "/v2/p2p/common/plan-selection",
				"isNavigationDeferred": true,
				"requestPayload": "{\\"postBackParams\\":{\\"isFromDashboard\\":\\"true\\"}}"
			}}`)
    }
  } catch (e: any) {
    console.log('error initiating the p2p investment flow to app', e.message)
  }
}

export const openMaturityPreferenceScreen = ({
  investmentId = '',
  accountId = null,
  maturityPreference = 'REINVEST'
}): void => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta", "extras": {
					"type": "CTA",
					"ctaType": "DEFAULT",
					"method": "POST",
					"navigationStyle": "PUSH",
					"url": "/v2/p2p/max/maturity-preference-post-investment",
					"requestPayload": "{\\"postBackParams\\":{\\"investmentId\\":\\"${investmentId}\\",\\"accountId\\":${
            accountId ? `\\"${accountId}\\"` : null
          }, \\"maturityPreference\\":\\"${maturityPreference}\\"}}" 
					}}`
      )
    }
  } catch (e: any) {
    console.error('Error opening maturity preference screen: ', e.message)
  }
}

export const openLoginScreen = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta", "extras": {
					"type": "CTA",
					"method": "GET",
					"navigationStyle": "PUSH",
					"url": "/v1/user-auth/enter-mobile-number"
				}}	
				`
      )
    }
  } catch (e: any) {
    console.error('Error opening login screen:  ', e.message)
  }
}

export const addBankAccountControls = (addBankAccountCta: any) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": ${JSON.stringify(addBankAccountCta)}}`)
    }
  } catch (e: any) {
    console.error('add bank account cta failed')
  }
}

export const viewBankAccountControls = (viewBankAccountCta: any) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta","extras": ${JSON.stringify(viewBankAccountCta)}}`)
    }
  } catch (e: any) {
    console.error('view bank account cta failed')
  }
}

export const categoryRelatedBottomSheets = (categoryId: string) => {
  const cta = {
    url: '/v1/explore/about-category',
    requestPayload: { inputData: { categoryId: categoryId } },
    method: 'POST',
    navigationStyle: 'BOTTOM_SHEET',
    navigateWithShuttleAnimation: false,
    ctaType: 'DEFAULT'
  }
  try {
    if (uniAppHandle) {
      postCTA(JSON.stringify(cta))
    }
  } catch (e: any) {
    console.error('category related bottom sheets failed')
  }
}

export const unlockFundBottomSheets = (unlockType: 'FUND_SCORES' | 'RANK' | 'PERFORMANCE' | 'RETURNS') => {
  const unlockFundCta = {
    ctaType: 'DEFAULT',
    method: 'POST',
    navigationStyle: 'BOTTOM_SHEET',
    url: '/v2/explore/elite-bottom-sheet',
    isNavigationDeferred: false,
    requestPayload: {
      postBackParams: {
        unlockType: unlockType
      }
    },
    navigateWithShuttleAnimation: false
  }
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta", "extras": ${JSON.stringify(unlockFundCta)}}`)
    }
  } catch (e: any) {
    console.error('unlock fund bottom sheets failed')
  }
}

export const setGoalPreferences = ({ investmentId = '', investmentGoal = 'VACATION' }) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta", "extras": {
					"type": "CTA",
					"ctaType": "DEFAULT",
					"method": "POST",
					"navigationStyle": "PUSH",
					"url": "/v2/p2p/max/goal-selection-post-investment",
					"requestPayload": "{\\"postBackParams\\":{\\"investmentId\\":\\"${investmentId}\\",\\"investmentGoal\\":\\"${investmentGoal}\\"}}" 
					}}	
				`
      )
    }
  } catch (e: any) {
    console.error('Error opening goal setting screen:  ', e.message)
  }
}

export const upgradeFlexiToMax = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta", "extras": {
					"type": "CTA",
					"ctaType": "DEFAULT",
					"method": "GET",
					"navigationStyle": "PUSH",
					"url": "/v2/p2p/flexi-to-fix/plan-selection"
					}}	
				`
      )
    }
  } catch (e: any) {
    console.error('Error occured while intiating upgrade to max screen:  ', e.message)
  }
}

export const openVideoPlayer = (videoUrl: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{
  "function": "screenResponse",
  "navigationStyle": "PUSH",
  "responseType" : "SCREEN",
  "responseName" : "InvestmentTabWebViewRedirectScreen",
  "type" : "WEB_VIEW",
  "url" : "${videoUrl}",
  "hardwareBackCta": {
  "type" : "CTA",
  "navigationStyle" : "NONE",
  "url" : ""
}
}`
      )
    }
  } catch (e: any) {
    console.error('Error occured while opening video player  ', e.message)
  }
}

export const popScreenAndRefresh = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function": "cta", "extras": {
					"type": "CTA",
      				"ctaType": "DEFAULT",
      				"navigationStyle": "POP_AND_REFRESH"
					}}	
				`
      )
    }
  } catch (e: any) {
    console.error('Error while popping app screen ', e.message)
  }
}

export const pushScreen = (url: String) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(
        `{"function":"cta",  "extras":{"type":"CTA","method":"GET","ctaType":"DEFAULT","navigationStyle":"${NavigationStyle.PUSH}","url":"${url}"}}`
      )
    }
  } catch (e) {
    // trackEvent(`APP_BIRDGE_goBack_ERROR`, { error: e })
  }
}

export const disableHardwareBack = (block: boolean = true) => {
  try {
    // if(uniAppHandle) {
    uniAppHandle.postMessage(`{"function":"setHardwareBackBlocked", "extras": {"shouldBlockHardwareBack": "${block}"}}`)
    // }
  } catch (e: any) {
    console.error('failed to disable hardware back', e)
  }
}

export const onReady = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function":"onReady"}`)
    }
  } catch (e: any) {
    console.error('Failed in triggering onReady ', e.message)
  }
}

export const postCTA = (ctaString: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "cta", "extras": ${ctaString}}`)
    }
  } catch (e: any) {
    console.error('Failed in post CTA ', e.message)
  }
}

export const postResponse = (responseString: string) => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage(`{"function": "response", "response": ${responseString}}`)
    }
  } catch (e: any) {
    console.error('Failed in post Response ', e.message)
  }
}

export const callOTP = () => {
  try {
    if (uniAppHandle) {
      uniAppHandle.postMessage('{"function":"autoFillOTP"}')
    }
  } catch (e: any) {
    console.error('Failed in post Auto Fill OTP ', e.message)
  }
}
